import { render, staticRenderFns } from "./EditTradeJournalModal.vue?vue&type=template&id=0b52ba64&scoped=true&"
import script from "./EditTradeJournalModal.vue?vue&type=script&lang=js&"
export * from "./EditTradeJournalModal.vue?vue&type=script&lang=js&"
import style0 from "./EditTradeJournalModal.vue?vue&type=style&index=0&id=0b52ba64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b52ba64",
  null
  
)

export default component.exports